import { CommonGet, CommonPost, CommonDelete } from "../../../utils/CommonFetch";

export default {
    getEstatesByGroupID,
    getDivisionByEstateID,
    saveSectionTimeConfiguration,
    getSectionTimeConfigurations,
    deleteSectionTimeConfiguration,
    updateSectionTimeConfiguration,
    getMenuCode
};

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id)
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
        }
    }
    return divisionArray;
}

async function saveSectionTimeConfiguration(saveData) {
    const response = await CommonPost('/api/SectionTimeConfiguration/SaveSectionTimeConfiguration', null, saveData);
    return response;
}

async function getSectionTimeConfigurations(data) {
    const response = await CommonPost('/api/SectionTimeConfiguration/GetSectionTimeConfigurations', null, data);
    return response.data;
}

async function deleteSectionTimeConfiguration(id, createdBy) {
    const response = await CommonPost('/api/SectionTimeConfiguration/DeleteSectionTimeConfiguration', 'id=' + id + '&createdBy=' + createdBy, null);
    return response;
}

async function getMenuCode(estateID) {
    const response = await CommonGet('/api/SectionTimeConfiguration/GetMenuCode', 'estateID=' + estateID);
    return response.data;
}

async function updateSectionTimeConfiguration(id, createdBy, startTime, endTime) {
    const data = {
        SessionTimeConfigurationID: id,
        startTime: startTime,
        endTime: endTime,
        createdBy: createdBy
    };
    const response = await CommonPost('/api/SectionTimeConfiguration/UpdateSectionTimeConfiguration', null, data);
    return response;
}
